// 活动类型枚举
export enum ActivityType {
  /** 年中大促 */
  MidYearPromotion = "midyear",
  /** 美妆精选 */
  BeautyPicks = "beautymakeup",
}

export enum MidYearPromotionCategory {
  /** 激励优惠 */
  IncentiveOffer = "incentive",
  /** 超级佣金 */
  SuperCommission = "super-comm",
  /** 限时抢购 */
  FlashSale = "flash-sale",
  /** 折扣专区 */
  DiscountSection = "dis-sec",
  /** 重点直播 */
  KeyLivestream = "key-live",
  /** 更多 */
  Category = "category",
}

export enum PageLevel {
  Level1 = "Lv1",
  Level2 = "Lv2",
}

/** 专区展示类型枚举 */
export enum MidYearSectionDisplayType {
  Product = "product" /* 展示商品组件 */,
  TextSwiper = "textSwiper" /* 展示文字轮播组件 */,
}

export enum searchV3Type {
  /** 电器 */
  Appliance = "601739",
  /** 家居 */
  Home = "600001",
  /** 美妆 */
  Beauty = "601450",
  /** 女性服饰*/
  Women = "601152",
}

export enum LowPriceTabKey {
  Day28SalesCount = "day28_sales_count",
  CreatorCommissionRate = "creator_commission_rate",
}

export enum HighCommCheckStatus {
  /** 未开始 */
  NotStarted = "not_started",
  /** 进行中 */
  InProgress = "in_progress",
  /** 暂停 */
  Paused = "paused",
  /** 已完成 */
  Completed = "completed",
}
